import React from "react";
import { ButtonContainer } from "../components/ButtonContainer";
import { RequestProjectFolderMove } from "./RequestProjectFolderMove";
import { ProjectFolder } from "../types";
import { CommandAuthorization, SharedDrive, SyncStatus } from "~/gql/types2";
import { CompleteProjectFolderMove } from "./CompleteProjectFolderMove";
import { OverrideProjectFolderSync } from "./OverrideProjectFolderSync";
import { Body1 } from "@material/react-typography";
import { IfAuthorized } from "~/components/IfAuthorized";

type ProjectFolderActionsProps = {
  folder: ProjectFolder;
  driveOptions: SharedDrive[];
};

export const ProjectFolderActions: React.FC<ProjectFolderActionsProps> = ({
  folder,
  driveOptions,
}) => {
  const hasError =
    folder.syncStatus === SyncStatus.Error ||
    folder.syncStatus === SyncStatus.RenameFailed;

  if (
    folder.syncStatus === SyncStatus.PendingMove &&
    folder.targetFolderPath != null
  ) {
    return (
      <IfAuthorized
        command={CommandAuthorization.CompleteProjectFolderMoveCommand}
      >
        <ButtonContainer>
          <CompleteProjectFolderMove folder={folder} />
        </ButtonContainer>
      </IfAuthorized>
    );
  }

  if (
    [SyncStatus.Error, SyncStatus.RenameFailed, SyncStatus.Unsynced].includes(
      folder.syncStatus
    )
  ) {
    return (
      <>
        {hasError && (
          <Body1>
            Sync error: {folder.syncErrorMessage ?? "Unhandled error"}
          </Body1>
        )}
        <IfAuthorized
          command={CommandAuthorization.OverrideProjectFolderSyncCommand}
        >
          <OverrideProjectFolderSync folder={folder} />
        </IfAuthorized>
      </>
    );
  }

  return (
    <IfAuthorized
      command={CommandAuthorization.RequestProjectFolderMoveCommand}
    >
      <ButtonContainer>
        <RequestProjectFolderMove folder={folder} driveOptions={driveOptions} />
      </ButtonContainer>
    </IfAuthorized>
  );
};
